<h3 class="message-title">
  <span class="message-icon" *ngIf="showIcon"><img [src]="icon"></span>
  {{message}}
</h3>
<p class="message-subtitle" *ngIf="!!subtitle">{{subtitle}}</p>
<div class="zupper-account-submit" *ngIf="showButton">
  <button class="message-display-button" (click)="buttonClick($event)">{{buttonLabel}}</button>
</div>
